module.exports = __webpack_public_path__ + "static/media/808RowLabel--BD.1555785a.svg";